export enum NetOrderType
{
    Subscription = 0,
    SpecificMonthTransaction = 1
}